/**
 * @file
 *
 * Provides and initializes legacy responsive sidebar navigation behavior.
 */

/*
	jquery.SecondaryNav

	Copyright (c) 2014 John David Parsons
	Licensed under the MIT, GPL licenses.

	Sets up a secondary navigation menu, with responsive behaviors

	$(document).ready(function(){
		$('nav', 'aside').SecondaryNav();
	});
*/

(function($) {
	$.fn.SecondaryNav = function(opts) {
		opts = $.extend({}, $.fn.SecondaryNav.options, opts);
		
		this.each(function() {
			var el = $(this);
			
			$(window).off('scroll', checkScroll);
			
			var nav = el.children('ul');
			var originalParent = el.parent();
			var navRow = nav.closest('.row');
			
			var originalIndex = el.index();
			// TODO: use the originalIndex to return the menu back to it's original position. Currently, this code forces the navigation to always be the first element in its container.
			
			nav.parent().find('#secondary-nav-toggle').remove(); // remove any existing button, in case this plugin has already been initialized (used by DirectoryProfile.js, for example)
			
			var mobileButton = $.fn.SecondaryNav.getMobileButton(nav);
			
			nav.before(mobileButton);
	
			function checkWidth() {
				var width = $(window).width();
				
				if (width <= opts.navJumpWidth) {
					if (navRow.children().first().is(el) === false) {
						// move nav to first child in .row
						el.prependTo(navRow);
						nav.slideUp(0);
						mobileButton.removeClass('display-none');
					} else { // we could be reinitializing this plugin, so make sure the right stuff is showing
						mobileButton.removeClass('display-none');
					}
				} else {
					//if (originalParent.children().first()[0] === el[0]) {
						// move nav to original parent
						originalParent.prepend(el);
				
						mobileButton.addClass('display-none');
						nav.slideDown(0);
					//}
				}
			}
	
			$(window).resize(function(){
				checkWidth();
				//affixedNavWidth();
			});
	
			checkWidth();
			//affixedNavWidth();
	
			var subNavs = nav.find('ul');
	
			subNavs.addClass('display-none');
	
			var links = nav.find('a');
			
			$.fn.SecondaryNav.checkCurrentUrl(el, links, undefined, true); // sends in the firstLoad flag, which will insert the current page's link if it does not already exist in the nav
			
			links = nav.find('a'); // we do this again because a new link may have been added by the method above
			
			$(window).off('scroll', checkScroll);
			$(window).on('scroll', checkScroll);
			
			var prevHash = '';
			
			// http://stackoverflow.com/questions/16889215/jquery-smooth-scroll-doesnt-change-url
			$('a[href*="#"]', 'aside').click(function() {
				var hash = this.hash;
		
				if (hash !== '#') { // if it's the main dropdown link, there's nowhere for the page to scroll, just expand the menu
					var target = $(hash);
					if (target.offset()) {
						//$(window).off('scroll', checkScroll);
						$('html, body').animate({ scrollTop: target.offset().top+1 }, 350, function (){
							history.pushState(null, null, hash); // this updates the hash without triggering the browser to try to jump to it
							$.fn.SecondaryNav.checkCurrentUrl(el, links);
							prevHash = hash;
						});
					}
				}
				//return false;
			});
			
			var reversedLinks = $(links.get().reverse());
			
			var curWindowUrl = $.fn.SecondaryNav.cleanUrl(window.location.href);
			
			reversedLinks.each(function(){
				var link = $(this);
				var linkhref = link.attr('href');
				
				// if the link is the full link like /e/the-path/index.html#the-hash, then remove the part before the #, and just have it be a pure hash on this page. This fixes an edge case where the current links didn't recognize the correct hash
				if (linkhref.indexOf('#') > -1 && $.fn.SecondaryNav.cleanUrl(linkhref.split('#')[0]) === $.fn.SecondaryNav.cleanUrl(curWindowUrl.split('#')[0])) {
					link.attr('href', '#' + linkhref.split('#')[1]);
				}
			});
			
			var isThrottled = false;

			function checkScroll(bypassThrottle) {
				if (bypassThrottle === undefined) {
					if (isThrottled) { return; }

					isThrottled = true;

					setTimeout(function () {
						isThrottled = false;
						//checkScroll(true);
					}, $.fn.SecondaryNav.options.hashUpdateScrollDelay);
				}
				
				var scrollTop = $(window).scrollTop();
				var foundHashLink = false;
				
				for (var i = 0; i < reversedLinks.get().length; i++) {
					var cur = $(reversedLinks[i]);
					
					if (cur.attr('href') !== '#' && cur.attr('href').indexOf('#') === 0) {
						var linkHash = cur.attr('href');
						var target = $(linkHash);
						
						if (target && target.size() > 0 && target.offset().top <= scrollTop + 1) {
							if (linkHash !== prevHash) {
								$.fn.SecondaryNav.checkCurrentUrl(el, links, linkHash);
								prevHash = linkHash;
							}
							foundHashLink = true;
							
							//console.log('found hash');
							
							break;
						}
					}
				}
				
				if (foundHashLink === false && prevHash !== '') {
					//console.log('set to non-hash link');
					$.fn.SecondaryNav.checkCurrentUrl(el, links, window.location.href.split('#')[0]);
					prevHash = '';
				}
				
			}
		});
		
		return this;
	};
	
	$.fn.SecondaryNav.checkCurrentUrl = function(el, links, overrideUrl, firstLoad) {
		var curUrl = '';
		
		if (overrideUrl && overrideUrl !== '') {
			curUrl = $.fn.SecondaryNav.cleanUrl(overrideUrl);
		} else {
			curUrl = $.fn.SecondaryNav.cleanUrl(window.location.href);
		}
		
		if (curUrl.indexOf('#') > -1) {
			curUrl = '#' + curUrl.split('#')[1];
		}
		
		/**
		 * Prevents query parameters from causing duplicate navigation items.
		 * 
		 * If the sidebar navigation (`<nav>`) has the `.ignore-query-params` class, 
		 * this ensures that only the base URL (excluding query parameters) is considered 
		 * when checking for existing nav items. This prevents duplicate links from being 
		 * added when query parameters (e.g., `?d=some-department`) change.
		 * 
		 * Initially implemented for the Faculty/Staff Directory but can be used elsewhere 
		 * if needed by adding `.ignore-query-params` to the sidebar `<nav>`.
		 */
		if (el.hasClass('ignore-query-params')) {
			curUrl = curUrl.split('?')[0]; // Remove everything after `?`
			curUrl = $.fn.SecondaryNav.cleanUrl(curUrl);
		}
		
		// reset all visibilities
		el.find('ul ul').addClass('display-none').removeClass('display-block');
		el.find('.current-parent').removeClass('current-parent');
		el.find('.current-parent-wrap').removeClass('current-parent-wrap');
		el.find('.current-last').removeClass('current-last');
		el.find('.current').removeClass('current');
		
		links.each(function(){
			var cur = $(this);
			var curhref = $.fn.SecondaryNav.cleanUrl(cur.attr('href'));
			
			if (curUrl === curhref) {
				$.fn.SecondaryNav.addCurrentClass(el, cur);
			} else if (curUrl.indexOf('#') > -1 && curUrl.split('#')[0] === curhref) {
				$.fn.SecondaryNav.addCurrentClass(el, cur);
			} else if (curUrl.indexOf('#') > -1 && $.fn.SecondaryNav.cleanUrl(window.location.href.split('#')[0]) === curhref) { // if it's a hash that isn't in a nav, just check the normal (no hash) url for a match
				$.fn.SecondaryNav.addCurrentClass(el, cur);
			}
		});
		
		/**
		 * Prevents the "no matched URL" fallback behavior.
		 *
		 * If the sidebar navigation (`<nav>`) has the `.ignore-no-match` class, the script
		 * will **not** execute `checkNoMatchedUrl`, preventing an extra menu item from being added
		 * when no matching URL is found.
		 */
		if (!el.hasClass('ignore-no-match') && firstLoad === true && 
			el.find('.current').size() <= 0 && 
			el.find('.current-parent').size() <= 0 && 
			el.find('.current-parent-wrap').size() <= 0 && 
			el.find('.current-last').size() <= 0) {
			$.fn.SecondaryNav.checkNoMatchedUrl(el, curUrl, links);
		}
		
	};
	
	$.fn.SecondaryNav.checkNoMatchedUrl = function(el, curUrl, links) {
		// if the current page's url is not in the navigation, we need to inject it into the correct place by finding the closest parent folder index.html that is in the nav. 
		
		var curUrlArr = curUrl.split('/');
		var trailingPage = curUrlArr[curUrlArr.length-1];
		
		var curUrlFolderPath = $.fn.SecondaryNav.trimTrailingChars(curUrl, '/' + trailingPage);
		
		curUrlFolderPath = $.fn.SecondaryNav.cleanUrl(curUrlFolderPath);
		
		var curFolderArr = curUrlFolderPath.split('/');
		
		for (var i = curFolderArr.length; i > 0; i--) {
			var testUrl = '';
			
			for(var j = 0; j < i; j++) {
				testUrl += curFolderArr[j] + '/';
			}
			
			testUrl = $.fn.SecondaryNav.trimTrailingChars(testUrl, '/');
			
			var curFound = false;
			
			links.each(function(){
				var curTest = $(this);
				var testhref = $.fn.SecondaryNav.cleanUrl(curTest.attr('href'));
			
				if (testhref !== '#') {
					if (testUrl === testhref) {
						// if a match is found, inject a new ul > li > a into this matched parent
						var pageNameArr = $('title').text().split(' | ');
						var pageName = pageNameArr[0];
						
						var injectedLink = $('<a href="' + window.location.href + '">' + pageName + '</a>');
						var injectedLi = $('<li></li>');
						injectedLi.append(injectedLink);
						
						if (curTest.siblings('ul').size() > 0) { // inject the new link to the existing sibling ul
							var existingUl = curTest.siblings('ul');
							
							existingUl.append(injectedLi);
						} else { // otherwise, create a new ul and add it after the current link
							// if the matched link is the very top link in the whole nav, we need to append this as a new <li> to the top-level <ul>. Otherwise, it should be a new <ul> as a child link of the matched <li> link
							
							if (curTest[0] === el.find('li:first a:first')[0]) {
								el.children('ul').first().append(injectedLi);
							} else {
								var injectedUl = $('<ul class="injected-no-match"></ul>');
							
								injectedUl.append(injectedLi);
							
								curTest.after(injectedUl);
							}
						}
						
						$.fn.SecondaryNav.addCurrentClass(el, injectedLink);
						
						curFound = true;
						
						return false;
					}
				}
			});
			
			if (curFound === true) {
				break;
			}
			
		}
	
	};
	
	
	$.fn.SecondaryNav.addCurrentClass = function(el, cur) {
		cur.addClass('current');

		var siblingUl = cur.siblings('ul');

		if (siblingUl.size() === 0 || siblingUl.find('a').size() === 0) { // if the ul has no child links, which will be the case if it's for the directory profiles, where we just use a placeholder <li id="jump-links">
			cur.addClass('current-last'); // this class makes the arrow point to the right, instead of pointing down
		}

		siblingUl.removeClass('display-none').addClass('display-block');
		cur.parentsUntil(el).removeClass('display-none').addClass('display-block');

		cur.parentsUntil(el).each(function(){
			var cur2 = $(this);
			if (cur2.is('ul')) {
				var parentLink = cur2.parent().children('a').first();
	
				parentLink.addClass('current-parent');
				parentLink.parent().addClass('current-parent-wrap');
			}
		});
		
		$(document).trigger('navChanged'); // this addCurrentClass method might change the number of links visible in a menu, so trigger this so that StickyNav can reset its height
	};
	
	// removes default page names from the end of a url, to normalize it to just the last folder, or just the current hash
	$.fn.SecondaryNav.cleanUrl = function(url) {
		url = url.toLowerCase();
		
		if (url.indexOf('elon.edu') > -1) {
			url = url.split('elon.edu')[1];
		}
		
		url = url.replace('index.html','').replace('index.htm','').replace('default.html','').replace('default.xhtml','');
		url = $.fn.SecondaryNav.trimTrailingChars(url, '/');
		
		return url;
	};
		
	// trims the trimString from the end of the original string
	$.fn.SecondaryNav.trimTrailingChars = function(original, trimString) {
		var regExp = new RegExp(trimString + '+$');
		var result = original.replace(regExp, '');
		
		return result;
	};
	
	$.fn.SecondaryNav.getMobileButton = function(nav) {
		// create hidden mobile nav button
		var mobileButton = $('<a href="#" id="secondary-nav-toggle" class="page-nav--mobile-toggle display-none"></a>');
		mobileButton.html('<i class="fa fa-bars"></i>' + nav.children('li').first().text() + ' Menu');

		mobileButton.click(function(){
			if (nav.is(':visible')) {
                mobileButton.addClass('nav-closed').removeClass('nav-open');
				nav.slideUp('fast');
			} else {
                mobileButton.addClass('nav-open').removeClass('nav-closed');
				nav.slideDown('down');
			}
	
			return false;
		});
		
		return mobileButton;
	};
	
	$.fn.SecondaryNav.options = {
		navJumpWidth: 800,
		hashUpdateScrollDelay: 500
	};
	
}(jQuery));

$(document).ready(function() {
	
	// only target nav elements inside of aside, because this should only target sidebars, and rare cases where there are two navigation elements in the same aside sidebar
    if (typeof $({}).SecondaryNav == 'function' && $('nav', 'aside.sidebar')[0]) {
		$('nav', 'aside').SecondaryNav();
	}
	
	// this is a workaround for when the #jump-links empty <li> needed for directory profiles exists in the nav on some other page that isn't the profile page, it would show an empty <ul> instead of being hidden
	$('ul', 'aside.sidebar nav').each(function() { 
		var ul = $(this);		
		if (ul.find('a').size() === 0) {
			ul.hide();
			ul.addClass('hide-ul');
		}
	});
	
});
